import { formatCurrency } from '@angular/common';
import { DEFAULT_CURRENCY_CODE, Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { CURRENCY } from 'src/app/_core/core.module';

@Pipe({
    name: 'currencyRange',
    standalone: false
})
export class CurrencyRangePipe<T> implements PipeTransform {

    constructor(
        @Inject(LOCALE_ID) public readonly localeId: string,
        @Inject(DEFAULT_CURRENCY_CODE) public readonly currencyCode: string,
        @Inject(CURRENCY) public readonly currencySymbol: string
    ) {
    }

    transform<T>(value: T, keyMin: keyof T, keyMax: keyof T): string {
        const minAmount = isNaN(+value[keyMin]) ? null : formatCurrency(+value[keyMin], this.localeId, this.currencySymbol);
        const maxAmount = isNaN(+value[keyMax]) ? null : formatCurrency(+value[keyMax], this.localeId, this.currencySymbol);

        if (minAmount && maxAmount) {
            return `De ${minAmount} à ${maxAmount}`;
        } else if (minAmount) {
            return `A partir de ${minAmount}`;
        } else if (maxAmount) {
            return `Jusqu'à ${maxAmount}`;
        }

        return null;
    }

}
